// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zy8f","index":"styles_index__39EZk"};